import React from 'react';
import { Table, Button, DropdownButton, MenuItem } from 'react-bootstrap';
import { getUser } from '../../utils/Common';
import { getReadableAccessLevel, getAccessColor } from '../access-control/utils';
export default function SharedCamerasTable({ 
  otherCaps, 
  user, 
  handleAccessChange, 
  renderLastAccess, 
  isMobile, 
  history 
}) {
  return (
    <Table bordered condensed striped hover className="cap-access-table">
      <thead>
        <tr>
          <th style={{ width: '200px' }}>Camera</th>
          <th style={{ width: '200px' }}>Access Level</th>
          <th style={{ width: '200px' }}>Last Access</th>
          <th style={{ width: '200px' }}>Builder</th>
        </tr>
      </thead>
      <tbody>
        {otherCaps.map(cap => {
          const backgroundColor = getAccessColor(cap.accessType);
          
          return (
            <tr key={cap.userCapId}>
              <td className="cap-name-cell">
                <Button
                  bsStyle="default"
                  onClick={() => history.push(`/caps/${cap.capId}`)}
                  className="cap-name-button"
                  style={{
                    whiteSpace: 'normal', 
                    textAlign: 'left',
                    fontSize: isMobile ? '0.8em' : 'inherit'
                  }}
                >
                  {cap.name}
                </Button>
              </td>
              <td>
                <DropdownButton
                  title={getReadableAccessLevel(cap.accessType)}
                  id={`dropdown-shared-${cap.userCapId}`}
                  onSelect={(newType) => handleAccessChange(user.userId, cap.capId, newType)}
                  style={{ backgroundColor }}
                >
                  <MenuItem eventKey="No Access" style={{ backgroundColor: getAccessColor('No Access')}}>{getReadableAccessLevel('No Access')}</MenuItem>
                  <MenuItem eventKey="DEMO" style={{ backgroundColor: getAccessColor('DEMO')}}>{getReadableAccessLevel('DEMO')}</MenuItem>
                  <MenuItem eventKey="VIEWER" style={{ backgroundColor: getAccessColor('VIEWER')}}>{getReadableAccessLevel('VIEWER')}</MenuItem>
                  <MenuItem eventKey="OWNER" style={{ backgroundColor: getAccessColor('OWNER')}}>{getReadableAccessLevel('OWNER')}</MenuItem>
                  {getUser().role==='ADMIN' && (<MenuItem eventKey="SALES_DEMO" style={{ backgroundColor: getAccessColor('SALES_DEMO')}}>{getReadableAccessLevel('SALES_DEMO')}</MenuItem>)}
                </DropdownButton>
              </td>
              <td>{renderLastAccess(cap.capId)}</td>
              <td className="cap-name-cell">
                <Button
                  bsStyle="default"
                  onClick={() => history.push(`/accesscontrol/${cap.builderId}`)}
                  className="cap-name-button"
                  style={{
                    whiteSpace: 'normal', 
                    textAlign: 'left',
                    fontSize: isMobile ? '0.8em' : 'inherit'
                  }}
                >
                  {cap.builder.name}
                </Button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
} 